export default {
  COLORS: 'colors',
  FONTS: 'fonts',
  BUTTONS: 'buttons',
  TEMPLATE_SWITCHING: 'template',
  EFFECTS: 'effects',
  OTHER_STYLES: 'other-styles',
};
